<template>
  <AdPageUnavailable :path="['decor.scenarios', 'decor.scenarios.questionnaires']">
    <v-layout>
      <v-flex>
        <QuestionnairesPanel />
      </v-flex>
    </v-layout>
  </AdPageUnavailable>
</template>

<script>
import QuestionnairesPanel from '@/components/Rule/QuestionnairesPanel'

export default {
  name: 'AdQuestionnaires',
  components: {
    QuestionnairesPanel
  },
  beforeRouteEnter (to, from, next) {
    if (to.name === 'questionnaires') {
      return next(async vm => {
        // Uncomment when listeners are active
        if (!vm.$store.state.questionnaire.loaded.questionnaires) {
          await vm.$store.dispatch('questionnaire/getQuestionnaireList')
            .catch(error => {
              const errorMessage = error?.response?.data?.description || error?.response?.statusText || 'Error'
              vm.$oops(errorMessage)
            })
        }
      })
    }
    next()
  },
  async beforeRouteUpdate (to, from, next) {
    if (!this.$store.state.questionnaire.loaded.questionnaires) {
      await this.$store.dispatch('questionnaire/getQuestionnaireList')
        .catch(error => {
          const errorMessage = error?.response?.data?.description || error?.response?.statusText || 'Error'
          this.$oops(errorMessage)
        })
    }
    if (from.params.prefix !== to.params.prefix) {
      const prefix = from.params.prefix
      this.sockets.unsubscribe(`GET/${prefix}/scheduled`)
    }
    next()
  },
  beforeRouteLeave (to, from, next) {
    const exceptions = ['questionnaires']
    const questionnairesLoaded = this.$store.state.questionnaire.loaded.questionnaires
    this.$store.commit('questionnaire/initQuestionnaires', exceptions)
    this.$store.commit('questionnaire/setLoaded', { key: 'questionnaires', status: questionnairesLoaded })
    next()
  }

}
</script>
